import { ITreeNode } from "./ITreeNode";

export class TerminateNode<T, C> extends ITreeNode<T, C> {
    constructor(identifier: string, data: T) {
        super(identifier, data);
    }
}
